import filedownload from 'js-file-download'
import { useContext } from '@nuxtjs/composition-api'

function parseProgress (event) {
  if (event.lengthComputable) {
    return event.loaded / event.total
  }
  return undefined
}

export default function useDownload () {
  const { $axios = {} } = useContext()

  async function download ({
    method = 'get',
    responseType = 'blob',
    filename = '',
    onProgress = () => {},
    url,
    ...config
  }) {
    const { data } = await $axios({
      method,
      responseType,
      url,
      onDownloadProgress: progress => onProgress(parseProgress(progress)),
      ...config,
    })
    // Do not download file if response is an error
    if (data === Symbol.for('error') || data instanceof Error) return data
    // Do not download file in tests
    if (process.env.NODE_ENV === 'test') return data
    return filedownload(data, filename)
  }

  return {
    download,
  }
}
